
<template>
    <div >
        <button
        @mousedown.prevent="dragMouseDown" class="chat-toggle-button"
        :class="{ 'has-new-message': hasNewMessage }"
        @click="isChatOpen = !isChatOpen; hasNewMessage = false"
            :style="chatStyle">
            <i class="pi pi-comments" style="font-size: 1.5rem"></i>
        </button>

        <div v-show="isChatOpen" class="chat-popup" :style="[chatStyle, popupStyle]" >
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: 1fr; align-items: center;">
                <i @click="toggleScale" :class="{  'pi pi-arrow-up-left': !isScaled, 'pi pi-arrow-down-right': isScaled }" style="justify-self: left; cursor: pointer"></i>
                <h1 style="">
                    Chat IoTag - Inteligência Artificial
                </h1>
            </div>
            <deep-chat
                id="chat-element"
                :demo.prop="false"
                focusMode='{"scroll": true}'
                :customButtons.prop="customButtons"
                :connect.prop="connectConfig"
                :requestInterceptor.prop="requestInterceptor"
                :responseInterceptor.prop="responseInterceptor"
                :style.prop="'border-color: #dcdcdc; background-color: #f3f6fc; margin: 0; width: 100%; height: 100%; padding-top: 1rem'"
                :avatars.prop="avatarProp"
                :textInput.prop="textInput"
                :messageStyles.prop="messageStyles"
                >
                <!--
                    :submitButtonStyles.prop='{"submit": {"container": {"default": {"height": "50%"}}}} TA QUEBRANDO O RESIZE'
                    :introMessage.prop="introMessage" -->
                    <div style="width: 60%; margin: auto; display: flex; flex-direction: column; align-items: center;">
                    <div
                        style="
                        width: 100%;
                        background-color: white;
                        border-radius: 10px;
                        padding: 12px;
                        padding-bottom: 15px;
                        margin-bottom: 1rem;
                        "
                        >
                        <div style="text-align: center;">
                            <div style="text-align: center; margin-bottom: 8px; font-size: 1.2rem">
                                <b>Bem-vindo ao Assistente virtual da IoTag.</b>
                            </div>
                            <div style="font-size: 1rem; line-height: 20px">
                                Aqui você pode consultar dados sobre veículos das suas organizações ou do dispositivo LinkDrive.
                                <br/><br/>
                                Alguns exemplos de perguntas seguem abaixo.
                            </div>
                        </div>
                    </div>
                    <div >
                        <div class="custom-button">
                            <div class="custom-button-text">"Qual veículo mais consumiu ontem?"</div>
                        </div>
                            <div class="custom-button" style="margin-top: 15px">
                            <div class="custom-button-text">"Qual veículo mais produziu nessa semana?"</div>
                        </div>
                            <div class="custom-button" style="margin-top: 15px">
                            <div class="custom-button-text">"Como configurar o LinkDrive corretamente?"</div>
                        </div>
                    </div>
                    </div>

            </deep-chat>
        </div>
    </div>
</template>

<script>
import 'deep-chat';
import axios from 'axios';
import iconeDispositivo from '@/assets/icons/icone-disp.svg'
import {mapGetters} from "vuex";
export default{
    data: () =>( {
        user_input: '',
        isChatOpen: false,
        isScaled: false,
        hasNewMessage: true,
        conversation_id: null,
        connectConfig: {}, // será preenchido no mounted()
        isDragging: false,
        // Posição atual do chat
        chatPosition: { x: 0, y: 0 },
        // Posição inicial do mouse e do elemento ao começar a arrastar
        dragStart: { x: 0, y: 0 },
        elementStart: { x: 0, y: 0 },
        popupCorrection: { x: 0, y: 0 },
        isClearMessageDisabled: true,
        customButtons: [],
        avatarProp: null,
        textInput: null,
        messageStyles: {}
    }),
    mounted() {
        this.avatarProp = {
            "default": {
                "styles": {"position": "left", "container": {"marginLeft": "12px", "marginRight": "5px"}}
                },
            "ai": {"src": iconeDispositivo, "styles": {"position": "left", "avatar": {"paddingTop": "6px"}}}
        }

        this.messageStyles={
            "default": {
                "shared": {"bubble": {"maxWidth": "100%", "backgroundColor": "unset", "marginTop": "10px", "marginBottom": "10px"}},
                "user": {"bubble": {"marginLeft": "0px", "color": "black"}},
                "ai": {"innerContainer": {"borderRadius": "15px", "backgroundColor": "white"}}
            }
        }

        this.introMessage = {
            "text": "Olá, sou seu assistente virtual. Aqui você pode consultar dados sobre seus veículos ou tirar dúvdas sobre o linkdrive. \n\nDicas para uma consulta assertiva:\n- Verifique se os nomes que deseja consutlar estão corretos;\n- Verifique a data de interesse da sua pergunta;"
        }
        this.textInput = {
            "styles": {
            "container": {"borderRadius": "20px", "border": "1px solid #969696", "boxShadow": "unset", "width": "78%", "marginLeft": "-15px"},
            "text": {"padding": "10px", "paddingLeft": "15px", "paddingRight": "34px"}
            },
            "placeholder": {"text": "Digite sua mensagem", "style": {"color": "#bcbcbc"}}
        }
        this.submitButtonStyles= {
          "content":
            "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\">\n<path d=\"M12 5V19M12 5L6 11M12 5L18 11\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>"
        }
        this.customButtons = [
            {
                "position": "outside-right",
                "onClick": () => !this.isClearMessageDisabled ? this.clearMessages() : {},
                "tooltip": {"text": "Apagar Chat"},
                "type": "disabled",
                "styles": {
                    "button": {
                        "default": {
                            "container": {
                                "default": {"border": "1px solid #e2e2e2", "borderRadius": "10px", "margin-left": "1rem", "margin-top": "1rem", "padding": "0.5rem"}
                            },
                                "svg": {
                                "content": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-0.5 0 25 25\"><path d=\"M9 3h6v-1.75c0-.066-.026-.13-.073-.177-.047-.047-.111-.073-.177-.073h-5.5c-.066 0-.13.026-.177.073-.047.047-.073.111-.073.177v1.75zm11 1h-16v18c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-18zm-10 3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm5 0c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm8-4.5v1h-2v18c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-18h-2v-1h7v-2c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v2h7z\"/></svg>"
                            },
                        },
                    }
                }
            }
        ]
        const chatElementRef = document.getElementById('chat-element');

        chatElementRef.htmlClassUtilities = {
            ['custom-button']: {
                events: {
                click: (event) => {
                    const text = event.target.children[0].innerText;
                    chatElementRef.submitUserMessage(text.substring(1, text.length - 1));
                },
                },
                styles: {
                default: {backgroundColor: '#3CBEB4', borderRadius: '10px', padding: '1rem', cursor: 'pointer', textAlign: 'center', color: 'white', fontSize: '1rem'},
                hover: {backgroundColor: '#379c94'},
                click: {backgroundColor: '#e4e4e4'},
                },
            },
        ['custom-button-text']: {styles: {default: {pointerEvents: 'none'}}},
        };
    },
    methods: {
        clearMessages(){
            const chatElementRef = document.getElementById('chat-element');
            chatElementRef.clearMessages();
            axios.delete(
                `${process.env.VUE_APP_BACKEND_ADDRESS}/chatbot-service/chat/${this.conversation_id}`,
                 {
                    headers: {
                        Authorization: `Bearer ${this.user.access_token}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).catch(error => {
                console.log(error)
            })
            this.isClearMessageDisabled = true;
            this.conversation_id = null;
        },
        requestInterceptor(requestDetails) {
            this.isClearMessageDisabled  = true;
            requestDetails.body = {user_input: requestDetails.body.messages[0].text, conversation_id: this.conversation_id ? this.conversation_id : null};
            return requestDetails;
        },
        responseInterceptor(response){
            this.conversation_id = response.conversation_id;
            if(!this.isChatOpen) this.hasNewMessage = true;
            this.isClearMessageDisabled = false;
            return {text: response.answer}
        },
         dragMouseDown(event) {
            this.isDragging = true;

            // Salva a posição inicial do clique do mouse
            this.dragStart.x = event.clientX;
            this.dragStart.y = event.clientY;

            // Salva a posição inicial do elemento
            this.elementStart.x = this.chatPosition.x;
            this.elementStart.y = this.chatPosition.y;

            // Adiciona "escutadores" de eventos globais para mover e soltar
            window.addEventListener('mousemove', this.dragMouseMove);
            window.addEventListener('mouseup', this.dragMouseUp);
        },

        dragMouseMove(event) {
            if (!this.isDragging) return;

            // Calcula o deslocamento do mouse desde o início
            const deltaX = event.clientX - this.dragStart.x;
            const popup = this.$el.querySelector('.chat-popup');
            const popupRect = popup.getBoundingClientRect();
            //const deltaY = event.clientY - this.dragStart.y;
            // Atualiza a posição do chat somando o deslocamento à posição inicial

            if(event.clientX < window.innerWidth && event.clientX > 0){
                this.chatPosition.x = this.elementStart.x + deltaX;
            }

            //this.chatPosition.y = this.elementStart.y + deltaY;
        },

        dragMouseUp() {
            this.isDragging = false;

            window.removeEventListener('mousemove', this.dragMouseMove);
            window.removeEventListener('mouseup', this.dragMouseUp);
        },
        toggleScale() {
            if (!this.isScaled) {
                this.isScaled = true;

                this.$nextTick(() => {
                    const popup = this.$el.querySelector('.chat-popup');
                    const toggleButton = this.$el.querySelector('.chat-toggle-button');
                    if (!popup || !toggleButton) return;

                    const popupRect = popup.getBoundingClientRect();
                    const buttonRect = toggleButton.getBoundingClientRect();
                    const margin = 20;

                    let offsetX = 0;
                    let offsetY = 0;


                    if (popupRect.right > window.innerWidth) {
                        offsetX = window.innerWidth - popupRect.right - margin;
                    }
                    if (popupRect.left < 0) {
                        offsetX = -popupRect.left + margin;
                    }
                    if (popupRect.top < 0) {
                        offsetY = -popupRect.top + margin;
                    }
                    if (popupRect.bottom > buttonRect.top) {
                        offsetY = buttonRect.top - popupRect.bottom - margin;
                    }

                    this.popupCorrection = { x: offsetX, y: offsetY };
                });
            }
            else {
                this.isScaled = false;
                this.popupCorrection = { x: 0, y: 0 };
            }
        },
    },
     beforeDestroy() {
        this.dragMouseUp();
    },
    watch: {
        user(user) {
            // Configuração do Deep Chat
            if (!user) {
                return;
            }
            this.connectConfig = {
                url: `${process.env.VUE_APP_BACKEND_ADDRESS}/chatbot-service/chat`,
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    'Content-Type': 'application/json'
                },

            };
        }
    },
    computed: {

        chatStyle() {
            return {
                transform: `translate(${this.chatPosition.x}px, ${this.chatPosition.y}px)`
            };
        },
        popupStyle() {
            // Combina a posição do arraste com a correção automática
            const totalX = this.chatPosition.x + this.popupCorrection.x;
            const totalY = this.chatPosition.y + this.popupCorrection.y;

            const translate = `translate(${totalX}px, ${totalY}px)`;
            const w = this.isScaled ? '35vw' : '30vw';
            const h = this.isScaled ? '65vh' : '60vh';
            return {
                transform: `${translate}`,
                width: w,
                height: h
            };
        },
        ...mapGetters([
            'user'
        ])
    }
}


</script>

<style scoped lang="scss">

$green: #008744;
$blue: #0057e7;
$red: #d62d20;
$yellow: #ffa700;
$white: #eee;

$width: 100px;

.chat-toggle-button {
  position: fixed; /* Fixa na tela, independente da rolagem */
  bottom: 20px;
  right: 20px;
  z-index: 999; /* Garante que fique acima de muitos elementos */
  background-color: #3CBEB4; /* Cor de sua preferência */
  color: white;
  border: none;
  border-radius: 50%; /* Deixa o botão redondo */
  width: 60px;
  height: 60px;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.1s ease-in-out;
}

@keyframes blink-animation {
  50% {
    background-color: #ff9800; /* Cor da notificação (laranja, por exemplo) */
    box-shadow: 0 0 25px rgba(255, 152, 0, 0.7);
  }
}

.chat-toggle-button:hover {
  transform: scale(1.1); /* Efeito ao passar o mouse */
  transition: background-color 0.3s, transform 0.2s ease-in-out;
}

.chat-toggle-button.has-new-message {
  animation-name: blink-animation;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

/* Estilo para a janela de chat pop-up */
.chat-popup {
  position: fixed; /* Fixa na tela */
  top: calc(100vh - 60vh - 90px);
  left: calc(100vw - 30vw - 20px);

  width: 30vw;
  height: 60vh;
  z-index: 1000; /* Garante que fique acima de TUDO */
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column; /* Para organizar o título e o chat */
  overflow: auto; /* Condição necessária para o 'resize' funcionar */
  transform-origin: top left;
  /*transition: width 0.5s ease-in-out, height 0.5s ease-in-out;*/
}

/* Ajusta o título dentro do pop-up */
.chat-popup div {
    padding: 1rem;
    background-color: #3CBEB4;
    color: white;
    margin: 0;
    border-bottom: 1px solid #ddd;
    text-align: center;
}

.chat-popup h1 {
    font-size: 1.2rem;
}

/* Garante que o componente deep-chat preencha o espaço restante */
.chat-popup deep-chat {
  flex-grow: 1; /* Ocupa todo o espaço vertical disponível */
}
</style>
